/**
 * Tabs Block Functionality
 *
 * @return {void}
 */
function initTabs() {
	const tabBlocks = document.querySelectorAll('.paragon-tabs-block');

	tabBlocks.forEach((tabBlock) => {
		const tabs = tabBlock.querySelectorAll('.pdm-tabs__nav-item');
		const tabContents = tabBlock.querySelectorAll(
			'.pdm-tabs__content-item'
		);

		tabs.forEach((tab) => {
			tab.addEventListener('click', function () {
				const tabId = tab.getAttribute('data-tab-controls');
				const tabContent = tabBlock.querySelector(
					`.pdm-tabs__content-item[data-tab-id="${tabId}"]`
				);

				if (tabContent) {
					// Toggle the data-active attribute.
					tabContents.forEach((content) => {
						content.setAttribute('data-active', 0);
					});
					tabContent.setAttribute('data-active', 1);
					// Set this tab to active and the rest to inactive.
					tabs.forEach((t) => {
						t.setAttribute('data-active', 0);
					});
					tab.setAttribute('data-active', 1);

					// Scroll this tab to the center of the container.
					const container = tab.parentElement;
					const containerRect = container.getBoundingClientRect();
					const tabRect = tab.getBoundingClientRect();
					const offset =
						tabRect.left -
						containerRect.left +
						container.scrollLeft -
						container.clientWidth / 2 +
						tabRect.width / 2;

					container.scroll({
						left: offset,
						behavior: 'smooth',
					});
				}
			});
		});
	});
}

document.addEventListener('DOMContentLoaded', function () {
	initTabs();
});
